import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';
import './app.css';


class SidenavContent extends Component {
  componentDidMount() {
    const {history} = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`;// get current path

    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, 'li');
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
            menuLi[j].classList.remove('open')
          }
        }
        this.classList.toggle('open');
      }
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  componentWillReceiveProps(nextProps) {

    const {history} = nextProps;
    const pathname = `${history.location.pathname}`;// get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] == 'function') {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {

    }

    return null;
  }

  render() {
    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">

          <li className="nav-header" style={{color: '#636363', fontSize: 15}}>
            <IntlMessages id="sidebar.menu"/>
          </li>

          <li className="nav-item">
          <NavLink to="/home">
              <span className="nav-text"><IntlMessages id="pages.home"/> </span>
            </NavLink>
          </li>

		  {
				this.props.authUser
				?
					this.props.authUser.id_tipo_usuario !== 19 &&
					<li className="nav-item">
					<NavLink to="/booking">
						<span className="nav-text"><IntlMessages id="pages.reservar"/> </span>
						</NavLink>
					</li>
				:
				<li className="nav-item">
					<NavLink to="/booking">
					<span className="nav-text"><IntlMessages id="pages.reservar"/> </span>
					</NavLink>
				</li>
			}

			{
				this.props.authUser
				?
					this.props.authUser.id_tipo_usuario !== 19 &&
					<li className="nav-item">
						<NavLink to="/packages">
						<span className="nav-text"><IntlMessages id="pages.paquetes"/> </span>
						</NavLink>
					</li>
				:
				<li className="nav-item">
					<NavLink to="/packages">
					<span className="nav-text"><IntlMessages id="pages.paquetes"/> </span>
					</NavLink>
				</li>
			}

          <li className="nav-item">
          <NavLink to="/blog">
              <span className="nav-text"><IntlMessages id="pages.blog"/> </span>
            </NavLink>
          </li>

          <li className="nav-item">
          <NavLink to="/mice">
              <span className="nav-text"><IntlMessages id="pages.mice"/> </span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/page/acerca-de">
              <span className="nav-text"><IntlMessages id="sidebar.extraPages.aboutUs"/> </span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/contact-us">
              <span className="nav-text"><IntlMessages id="sidebar.extraPages.contactUs"/> </span>
            </NavLink>
          </li>

        </ul>
      </CustomScrollbars>
    );
  }
}

const mapStateToProps = ({auth}) => ({
	authUser: auth.authUser,
});

export default withRouter(connect(mapStateToProps,{
})(SidenavContent));

// export default withRouter(SidenavContent);
